export enum DocumentApprovalStatus {
  APPROVED = 'Approved',
  REJECTED = 'Rejected',
  VOID = 'Void',
}
